// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.
import PropTypes from "prop-types";

import defaultIcon from "images/missing_icon.svg";
import { classes } from "utils/classes";

import styles from "./ImgIcon.scss";

/**
 * @typedef {Object} ImgIconProps
 * @property {string} [src=null] - Link or path to image; placeholder displayed if src not provided
 * @property {string} [className] - Additional CSS class names for styling
 */

/**
 * ImgIcon component that displays an image with a fallback to a default icon
 * @param {ImgIconProps} props - The component props
 * @returns {JSX.Element} The rendered image icon component
 */
export const ImgIcon = ({ src = null, className }) => {
  return (
    <img
      className={classes(styles.container, className)}
      src={src || defaultIcon}
    />
  );
};

ImgIcon.propTypes = {
  src: PropTypes.string,
  className: PropTypes.string,
};

export default ImgIcon;
